/**
 * Elapsed seconds as HH:MM:SS.
 *
 * Written out because the obvious shortcut is wrong:
 *
 *   new Date(seconds * 1000).toISOString().slice(11, 19)
 *
 * reads the time-of-day out of an epoch timestamp, so anything from 24 hours up
 * wraps silently - a 25h10m trip rendered as 01:10:00, an hour and ten minutes.
 * Long trips are exactly what phone trackers produce.
 *
 * Hours are not capped at two digits: a duration that genuinely ran for 100
 * hours should say so rather than lose a day.
 */
export function formatDuration(seconds) {
    if (seconds === null || seconds === undefined || seconds === '') return '';

    const total = Math.floor(Number(seconds));
    // A negative or non-numeric duration is not a measurement to render.
    if (!Number.isFinite(total) || total < 0) return '';

    const pad = (n) => String(n).padStart(2, '0');
    return [
        pad(Math.floor(total / 3600)),
        pad(Math.floor(total / 60) % 60),
        pad(total % 60),
    ].join(':');
}
